import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import React from 'react';

export default function LockPromptDialog(props) {
    const { onClose, open, content } = props;

    const handleOk = () => {
        onClose();
    };

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
        >
            <DialogContent dividers>
                <pre id="lock-message-dialog-description" dangerouslySetInnerHTML={{ __html: content }}
                    style={{
                        margin: 0,
                        fontSize: '1rem',
                        fontFamily: 'Arial',
                        whiteSpace: 'pre-line',
                        wordBreak: 'break-word',
                        wordWrap: 'break-word',
                        lineHeight: 1.43
                    }}
                ></pre>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleOk} color="primary">OK</Button>
            </DialogActions>
        </Dialog>
    )
}
